import { createRouter, createWebHistory } from "vue-router";
import { routeAvailable } from "../util/integrations";

// import store from '@/store';

const routes = [
	{
		path: "/",
		component: () => import(/* webpackChunkName: "main" */ "../views/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/Dashboard"),
			},
			{
				path: "/:catchAll(.*)",
				component: () => import(/* webpackChunkName: "404" */ "../views/404"),
			},
			{
				path: "/activiteiten/:catchAll(.*)",
				component: () => import(/* webpackChunkName: "404" */ "../views/404-activiteiten"),
			},
		],
	},
	{
		path: "/404",
		component: () => import(/* webpackChunkName: "main" */ "../views/__template_404"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/404"),
			},
		],
	},
	{
		path: "/bedrijfspagina",
		
		component: () => import(/* webpackChunkName: "main" */ "../views/companypages/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/companypages/Overview"),
				
			},
			{
				path: "concept",
				component: () => import(/* webpackChunkName: "main" */ "../views/companypages/Concept"),
			},
		],
	},
	{
		path: "/openbare-pagina",
		component: () => import(/* webpackChunkName: "main" */ "../views/publicpage/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/publicpage/Overview"),
			},
			{
				path: "activiteiten",
				component: () => import(/* webpackChunkName: "main" */ "../views/publicpage/View"),
			},
		],
	},


	{
		path: "/formulier/:id",
		component: () => import(/* webpackChunkName: "main" */ "../views/single_intakeform/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/single_intakeform/View"),
			},

		],
	},
	{
		path: "/linkformulier/:id",
		component: () => import(/* webpackChunkName: "main" */ "../views/link_intakeform/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/single_intakeform/View"),
			},

		],
	},
	{
		path: "/intakeformulieren",
		meta: { requires: ["flexwell", "zoho"] },
		component: () => import(/* webpackChunkName: "main" */ "../views/intakeforms/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/intakeforms/Overview"),
			},
			{
				path: ":id",
				component: () => import(/* webpackChunkName: "main" */ "../views/intakeforms/View"),
			},
			{
				path: ":id/bewerken",
				component: () => import(/* webpackChunkName: "main" */ "../views/intakeforms/Edit"),
			},
		],
	},
	{
		path: "/contact",
		component: () => import(/* webpackChunkName: "main" */ "../views/contact/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/contact/Overview"),
			},

		],
	},
	{
		path: "/activiteiten",
		component: () => import(/* webpackChunkName: "main" */ "../views/companypages/Overview"),
	},

	// De Specialistlink (ADR-0063). Geen sessie: het token in de URL is de
	// autorisatie, en hetzelfde Aanmeldingenoverzicht draait erop -- de rijvorm is
	// identiek, alleen de scope en de basis-URL van de acties verschillen.
	{
		path: "/link/:token",
		component: () => import(/* webpackChunkName: "main" */ "../views/activities/Registrations"),
		props: (route) => ({ token: route.params.token }),
	},

	{
		path: "/activiteiten/:id",
		component: () => import(/* webpackChunkName: "main" */ "../views/activities/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/activities/View"),
			},
			{
				path: "aanmeldingen",
				component: () => import(/* webpackChunkName: "main" */ "../views/activities/Registrations"),
			},
		],
	},
	{
		path: "/accountgegevens",
		component: () => import(/* webpackChunkName: "main" */ "../views/account/__template"),
		children: [
			{
				path: "",
				component: () => import(/* webpackChunkName: "main" */ "../views/account/Overview"),
			},
		],
	},
	{
		path: "/afspraak-bevestigen",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/confirmation/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/confirmation/Overview"),
			},
		],
	},
	{
		path: "/verbinden",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/connect/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/connect/Overview"),
			},
		],
	},

	// {
	// 	path: "/instellingen",
	// 	component: () => import(/* webpackChunkName: "main" */ "../views/settings/__template"),
	// 	children: [
	// 		{
	// 			path: "",
	// 			component: () => import(/* webpackChunkName: "main" */ "../views/settings/Overview"),
	// 		},
	// 	],
	// },
	{
		path: "/review",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/review/__template"),
		children: [
			{
				path: ":id",
				component: () => import("../views/review/View"),
			},
		],
	},

	{
		path: "/inloggen",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Login"),
			},
			{
				path: "otp",
				component: () => import("../views/auth/OTP"),
			},
		],
	},

	{
		path: "/wachtwoord-vergeten",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Resetpassword"),
			},
		],
	},

	{
		path: "/wachtwoord-wijzigen",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Newpassword"),
			},
		],
	},

	{
		path: "/registreren",
		component: () => import(/* webpackChunkName: "werkgevers" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Register"),
			},
		],
	},

	{
		path: "/registratie-voltooien",
		component: () => import(/* webpackChunkName: "register confirm" */ "../views/auth/__template"),
		children: [
			{
				path: "",
				component: () => import("../views/auth/Registerconfirm"),
			},
		],
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

// A page whose integration is off in the config sends you to the dashboard.
router.beforeEach((to) => (routeAvailable(to) ? true : "/"));



export default router;
